var _style, _circle, _path, _path2, _path3, _path4, _feBlend, _feBlend2, _feBlend3, _feBlend4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 838 154",
    style: {
      enableBackground: "new 0 0 838 154"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000049198876980399170970000013619023096710316972_);}\n\t.st3{opacity:0.1;fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_00000057833871928189587460000000519011728029176464_);}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_00000056410490722020169480000010215634025069681541_);}\n\t\n\t\t.st7{mask:url(#SVGID_00000119811608733591725810000014201293489243567273_);fill:url(#SVGID_00000055692165788428203440000007359980383396428193_);}\n\t.st8{fill:url(#SVGID_00000098938707560582445310000006132637903860803223_);}\n\t.st9{filter:url(#Adobe_OpacityMaskFilter_00000120547805910823490490000004227237758725197976_);}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_00000170956646555898807410000008978608831027092364_);}\n\t\n\t\t.st11{mask:url(#SVGID_00000073714455083426364670000013372383878426395300_);fill:url(#SVGID_00000042009137774594670160000012837100524603055011_);}\n\t.st12{fill:url(#SVGID_00000033363592006050411820000006339389147382762921_);}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 784.8,
    cy: 21.4,
    r: 4.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.1,25.5c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9S799.1,23.9,799.1,25.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -9.940777e-10,
    y1: 80.5992,
    x2: 838,
    y2: 80.5992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#F7CD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F79D00"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M768,150.6H70c-38.7,0-70-31.3-70-70v0c0-38.7,31.3-70,70-70h698c38.7,0,70,31.3,70,70v0 C838,119.3,806.7,150.6,768,150.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014610834900066960880000016700228947744316827_",
    gradientUnits: "userSpaceOnUse",
    x1: 419,
    y1: 143.4394,
    x2: 419,
    y2: 3.435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEC25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014610834900066960880000016700228947744316827_)"
    },
    d: "M768,143.4H70c-38.7,0-70-31.3-70-70v0 c0-38.7,31.3-70,70-70h698c38.7,0,70,31.3,70,70v0C838,112.1,806.7,143.4,768,143.4z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M768,3.4H70c-38.7,0-70,31.3-70,70v0c0,8.8,1.6,17.2,4.6,25C14.6,72.1,40.1,53.3,70,53.3h698 c29.9,0,55.4,18.7,65.4,45.1c3-7.8,4.6-16.2,4.6-25v0C838,34.8,806.7,3.4,768,3.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70,53.3h698c26.7,0,49.9,15,61.7,37c-11.8-25-35-42.1-61.7-42.1H70c-26.7,0-49.9,17-61.7,42.1 C20.1,68.3,43.3,53.3,70,53.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075123477499662346780000004871408237406928020_",
    gradientUnits: "userSpaceOnUse",
    x1: 419,
    y1: 143.4393,
    x2: 419,
    y2: 3.435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F79D00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEC25"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075123477499662346780000004871408237406928020_)"
    },
    d: "M768,10.6c34.7,0,62.8,28.2,62.8,62.8 c0,34.7-28.2,62.8-62.8,62.8H70c-34.7,0-62.8-28.2-62.8-62.8c0-34.7,28.2-62.8,62.8-62.8H768 M768,3.4H70c-38.7,0-70,31.3-70,70v0 c0,38.7,31.3,70,70,70h698c38.7,0,70-31.3,70-70v0C838,34.8,806.7,3.4,768,3.4L768,3.4z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 233,
    y: 3.4,
    width: 369.4,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 3.4,
    width: 369.4,
    height: 7.2,
    id: "SVGID_00000056425984925129700160000012955753586994207148_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000035496174505893478610000010717574878941024676_",
    filterUnits: "userSpaceOnUse",
    x: 233,
    y: 3.4,
    width: 369.4,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 3.4,
    width: 369.4,
    height: 7.2,
    id: "SVGID_00000056425984925129700160000012955753586994207148_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000035496174505893478610000010717574878941024676_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152956184839654066740000002419627917317230014_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.9503,
    y1: 6.9796,
    x2: 602.3862,
    y2: 6.9796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 3.4,
    style: {
      mask: "url(#SVGID_00000056425984925129700160000012955753586994207148_)",
      fill: "url(#SVGID_00000152956184839654066740000002419627917317230014_)"
    },
    width: 369.4,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090266347512685363620000004552537591225866422_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.9503,
    y1: 6.9796,
    x2: 602.3862,
    y2: 6.9796
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEC92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFECB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEC92"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 3.4,
    style: {
      fill: "url(#SVGID_00000090266347512685363620000004552537591225866422_)"
    },
    width: 369.4,
    height: 7.2
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147927027912792248750000009149040794939706253_",
    filterUnits: "userSpaceOnUse",
    x: 150.3,
    y: 143.4,
    width: 504.9,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 150.3,
    y: 143.4,
    width: 504.9,
    height: 7.2,
    id: "SVGID_00000172420718037578422370000001555220356616132258_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000147927027912792248750000009149040794939706253_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000037677864396744927750000005324741062297186478_",
    filterUnits: "userSpaceOnUse",
    x: 150.3,
    y: 143.4,
    width: 504.9,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 150.3,
    y: 143.4,
    width: 504.9,
    height: 7.2,
    id: "SVGID_00000172420718037578422370000001555220356616132258_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000037677864396744927750000005324741062297186478_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112604560239821068770000006490355697680294573_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.3474,
    y1: 147.0203,
    x2: 655.2747,
    y2: 147.0203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 143.4,
    style: {
      mask: "url(#SVGID_00000172420718037578422370000001555220356616132258_)",
      fill: "url(#SVGID_00000112604560239821068770000006490355697680294573_)"
    },
    width: 504.9,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088833355684655332960000009925469432078311346_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.3474,
    y1: 147.0203,
    x2: 655.2747,
    y2: 147.0203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFEC92"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFECB0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFEC92"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 143.4,
    style: {
      fill: "url(#SVGID_00000088833355684655332960000009925469432078311346_)"
    },
    width: 504.9,
    height: 7.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonYellow);
export default __webpack_public_path__ + "static/media/button-yellow.a212be856cd9a2c4fad9557e5ff96dde.svg";
export { ForwardRef as ReactComponent };